import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-movie-2-line text-background-50 text-lg"></i>
            </div>
            <span className="text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              极速影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            {categories.filter((c) => c.slug !== 'all').slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电影..."
                className="w-48 px-4 py-2 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">
              首页
            </Link>
            {categories.filter((c) => c.slug !== 'all').slice(0, 8).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}